import { render, staticRenderFns } from "./HomeOnboardTab.vue?vue&type=template&id=1985646e"
import script from "./HomeOnboardTab.vue?vue&type=script&lang=js"
export * from "./HomeOnboardTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports